import { css } from 'lit';

export const DxoStylesTextBanner = css`
  .text-banner-wrapper {
    max-width: 1216px;
    margin: 0 auto;
  }

  .text-banner-background-white {
    background: #ffffff;
  }

  .text-banner-background-gray {
    background: #f4f4f4;
  }

  .tex-banner-font {
    font-family: Optimist, 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif;
    font-style: normal;
    -moz-osx-font-smoothing: grayscale;
    -webkit-font-smoothing: antialiased;
  }
  .text-banner-content {
    box-sizing: border-box;
  }

  p {
    margin: 0px;
  }

  .text-banner-eyebrow-text {
    font-family: 'Optimist';
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    text-align: center;
    letter-spacing: 0.5px;
    text-transform: uppercase;
    padding-top: 56px;
  }

  .text-banner-headline-text {
    font-family: 'Optimist';
    font-style: normal;
    font-weight: 300;
    font-size: 32px;
    line-height: 42px;
    text-align: center;
  }

  .pad_top--no-brow {
    padding-top: 56px;
  }

  .pad_top--with-brow {
    padding-top: 56px;
  }

  ::slotted(p) {
    max-width: 928px;
    margin: 0 auto;
  }

  ::slotted(p) {
    font-family: 'Optimist';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    padding-top: 16px;
    text-align: left;
    padding-left: 24px;
    padding-right: 24px;
  }

  .pad_bot--no-cta {
    padding-bottom: 72px;
  }

  .text-banner-actions {
    padding-bottom: 72px;
    text-align: center;
  }

  .pad_top--no-subheadline {
    padding-top: 32px;
  }

  .pad_top--with-subheadline {
    padding-top: 40px;
  }

  @media only screen and (min-width: 769px) {
    .text-banner-eyebrow-text {
      padding-top: 72px;
    }
    .text-banner-headline-text {
      font-size: 40px;
      line-height: 52px;
    }
    .pad_top--no-brow {
      padding-top: 72px;
    }
    ::slotted(p) {
      font-weight: 300;
      font-size: 20px;
      line-height: 30px;
      text-align: center;
      padding-left: 48px;
      padding-right: 48px;
    }
  }

  @media only screen and (max-width: 375px) {
    .text-banner-headline-text {
      padding-left: 24px;
      padding-right: 24px;
      text-align: left;
    }
    .pad_top--with-brow {
      padding-top: 40px;
    }
    .text-banner-actions {
      text-align: left;
      padding-left: 24px;
    }
  }
`;
